import StatusTag from 'components/ui/base/status/StatusTag';

type Props = {
    status: 'complete' | 'incomplete';
};

const ConfigurationStatus = ({ status }: Props) => {
    const color = status === 'complete' ? 'var(--success-normal)' : 'var(--warning-normal)';
    const text = status === 'complete' ? 'Configured' : 'Incomplete';
    return <StatusTag color={color} status={text} size="medium" />;
};

export default ConfigurationStatus;
